import { Dialog } from '@mui/material'
import Button from '@mui/material/Button'
import { CSSProperties, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

import ActionContainer from 'components/containers/actionContainer'
import FlatLayout from 'components/layouts/flatLayout'
import ModalLayout from 'components/layouts/modalLayout'
import PageTitleComponent from 'components/parts/pageTitle'
import { securityFieldApi } from 'hooks/api/securityField'
import SecurityFieldRegisterModal from 'pages/securityField/components/securityFieldRegisterModal'
import SecurityFieldTableComponent from 'pages/securityField/components/securityFieldTable'
import { addSnackbar } from 'store/snackbarSlice'
import { SecurityField } from 'types/securityField'
import { Icons } from 'variables'

const apiCall = {
  add: async (name: string) => {
    await securityFieldApi().add({
      name: name,

      // 詳細画面で設定する項目は空で登録
      phone: '',
      email: '',
    })
  },
  delete: async (securityFieldIds: string[]) => {
    await securityFieldApi().bulkDelete({
      securityFieldIds: securityFieldIds,
    })
  },
  allData: async () => {
    const response = await securityFieldApi().filter()
    return response.data
  },
}

export default function SecurityFieldPage() {
  const dispatch = useDispatch()
  const [securityFields, setSecurityFields] = useState<SecurityField[]>([])
  const [checkedIds, setCheckedIds] = useState<string[]>([])
  const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false)

  const fetch = async () => {
    const response = await apiCall.allData()
    setSecurityFields(response)
  }

  useEffect(() => {
    fetch().then()
  }, [])

  const handleCheck = (securityFieldIds: string[]) => {
    setCheckedIds(securityFieldIds)
  }

  const handleSave = (data: { name: string }) => {
    const apiAction = async () => {
      await apiCall.add(data.name)
      await fetch()
      dispatch(
        addSnackbar({ message: '警備先を登録しました', severity: 'success' }),
      )
      setIsRegisterModalOpen(false)
    }

    apiAction().then()
  }

  const handleAdd = () => {
    setIsRegisterModalOpen(true)
  }

  const handleDelete = () => {
    if (
      // 誰も選択していない場合は何も起きない
      checkedIds.length === 0 ||
      // 突然消えると怖いので、確認ダイアログを打ち上げる
      !window.confirm(`${checkedIds.length}個削除されます。\nよろしいですか？`)
    )
      return

    const apiAction = async () => {
      await apiCall.delete(checkedIds)
      await fetch()
      dispatch(
        addSnackbar({ message: '警備先を削除しました', severity: 'success' }),
      )
    }

    apiAction().then()
  }

  const handleCancel = () => {
    setIsRegisterModalOpen(false)
  }

  return (
    <>
      <FlatLayout title="警備先">
        <PageTitleComponent>警備先一覧</PageTitleComponent>
        <ActionContainer style={actionContainerStyle}>
          <Button variant="outlined" onClick={handleAdd}>
            <Icons.addButton />
            追加
          </Button>
          <Button variant="outlined" onClick={handleDelete}>
            <Icons.deleteButton />
            削除
          </Button>
        </ActionContainer>
        <SecurityFieldTableComponent
          securityFields={securityFields}
          onChangeChecked={handleCheck}
        />
      </FlatLayout>
      <Dialog open={isRegisterModalOpen}>
        <ModalLayout title="警備先登録">
          <SecurityFieldRegisterModal
            onSave={handleSave}
            onCancel={handleCancel}
          />
        </ModalLayout>
      </Dialog>
    </>
  )
}

const actionContainerStyle: CSSProperties = {
  marginBottom: '8px',
}
